// Keys for localstorage
export enum LocalStorageKey {
    PRODUCT_UPDATE_DISMISSED = "product-update-dismissed",
    PRODUCT_UPDATE_VERSION = "product-update-version",

    WEATHER_CARD_UNIT_SYSTEM = "weather-card-unit-system",

    MULTIDEPTH_GRAPH_SETTINGS = "multi-depth-graph-settings",

    ZONE_ACTIVITY_LANES_OPEN = "zone-activity-lanes-open",
    // TODO casing should be changed to kebab case and existing user's keys migrated
    // ref: https://linear.app/verdiag/issue/SWD-2957/change-locale-local-storage-key-casing
    LANGUAGE_SETTING = "languageSetting",
}

// Get value from localStorage
const getLocalStorageValue = (key: LocalStorageKey): unknown | undefined => {
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : undefined;
    } catch (error) {
        console.error(`Error reading localStorage key "${key}":`, error);
        return undefined;
    }
};

// Set value in state and localStorage
const setLocalStorageValue = (key: LocalStorageKey, value: unknown) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(`Error setting localStorage key "${key}":`, error);
    }
};

// Clear value from localStorage
const clearLocalStorageValue = (key: LocalStorageKey) => {
    try {
        window.localStorage.removeItem(key);
    } catch (error) {
        console.error(`Error clearing localStorage key "${key}":`, error);
    }
};

export { clearLocalStorageValue, getLocalStorageValue, setLocalStorageValue };
